import axios from "axios";
import * as yup from "yup";
import { Formik, Form as FormikForm } from "formik";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useCartContext } from "../../context/CartContext";
import { useProductContext } from "../../context/ProductContext";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import FormatPrice from "../../components/FormatPrice";

const initialValues = {
  payment_method: "",
  customer: "",
  delivery_type: "",

  total_amount: "",
  discount: "",
  payable_amount: "",
  paid_amount: "",
  due_amount: "",
  delivery_charge: "",
  grand_total_amount: "",

  name: "",
  email: "",
  password: "",
  district: "",
  upazila: "",
  address: "",
};

const schema = yup.object().shape({
  // payment_method: yup.string().required("Payment Method is a required field!"),
  customer: yup.string(),
  delivery_type: yup.string().required("Delivery Type is a required field!"),

  total_amount: yup.string(),
  discount: yup.string(),
  payable_amount: yup.string(),
  paid_amount: yup.string(),
  due_amount: yup.string(),
  delivery_charge: yup.string(),
  grand_total_amount: yup.string(),
});

const validate = (values) => {
  let errors = {};

  return errors;
};

const customerSchema = yup.object().shape({
  // payment_method: yup.string().required("Payment Method is a required field!"),
  customer: yup.string(),
  delivery_type: yup.string().required("Delivery Type is a required field!"),

  total_amount: yup.string(),
  discount: yup.string(),
  payable_amount: yup.string(),
  paid_amount: yup.string(),
  due_amount: yup.string(),
  delivery_charge: yup.string(),
  grand_total_amount: yup.string(),

  name: yup.string().required("Customer Name is a required field!"),
  email: yup.string().required("Customer Phone is a required field!"),
  // password: yup.string().required("Password is a required field!"),
  // district: yup.string().required("Customer District is a required field!"),
  // upazila: yup.string().required("Customer Upazila is a required field!"),
  address: yup.string().required("Customer Address is a required field!"),
});

const customerValidate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = "Phone or Username is required!";
  } else if (/^[0-9\b]+$/.test(values.email) === false) {
    errors.email = "Only number!";
  } else if (values.email.length !== 11) {
    errors.email = "Mobile Number contains 11 digit!";
  }

  if (values.password) {
    if (values.password.length < 4) {
      errors.password = "Password is too short!";
    }
  }
  return errors;
};

const Ordercheckout = ({ aT, c_user }) => {
  const Base_URL = process.env.REACT_APP_BASE_URL;
  const Register_URL = process.env.REACT_APP_REGISTER_URL;
  const Order_URL = process.env.REACT_APP_ORDER_URL;
  const Customer_Register_Post_URL = `${Base_URL}${Register_URL}`;
  const Customer_Order_Post_URL = `${Base_URL}${Order_URL}`;

  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const {
    order,
    order_total_price,
    order_total_discount,
    paid_amount,
    clearOrder,
  } = useCartContext();
  const { district, upazila, unpaginate_delivery_type } = useProductContext();
  const isActiveDeliveryType =
    unpaginate_delivery_type &&
    unpaginate_delivery_type.filter((item) => item.d_status === true);

  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const handleDelTypeChange = (e) => {
    const selectedDeliveryTypeId = parseInt(e.target.value); // Assuming delivery type IDs are integers

    // Find the selected delivery type from the unpaginate_delivery_type array
    const selectedDeliveryType = unpaginate_delivery_type.find(
      (item) => item.id === selectedDeliveryTypeId
    );

    // Update the state with the selected delivery type's price
    if (selectedDeliveryType) {
      setDeliveryPrice(selectedDeliveryType.price); // Update state with selected delivery type price
    } else {
      setDeliveryPrice(null); // Clear delivery price if no delivery type is selected
    }
  };

  const AddCustomerFunc = async (values) => {
    let formfield = new FormData();

    // Append individual fields
    formfield.append("name", values.name);
    formfield.append("email", values.email);
    formfield.append("password", values.password ? values.password : "123456");
    formfield.append("district", values.district ? values.district : "ABC");
    formfield.append("upazila", values.upazila ? values.upazila : "ABC");
    formfield.append("address", values.address);

    await axios({
      method: "POST",
      url: Customer_Register_Post_URL,
      headers: {
        "Content-Type": "application/json; charset=UTF-8; text/plain",
      },
      data: formfield,
    })
      .then((response) => {
        const AddOrderFunc = async () => {
          let formfield = new FormData();

          values.total_amount = order_total_price;
          values.discount = order_total_discount;
          values.payable_amount = order_total_price - order_total_discount;
          values.paid_amount = paid_amount;
          values.due_amount =
            order_total_price - order_total_discount - paid_amount;
          values.delivery_charge = deliveryPrice;
          values.grand_total_amount =
            order_total_price -
            order_total_discount -
            paid_amount +
            Number(deliveryPrice);

          // Append individual fields
          formfield.append(
            "payment_method",
            values.payment_method ? values.payment_method : "Cash On Delivery"
          );
          formfield.append("customer", Number(response.data.id));
          formfield.append("delivery_type", Number(values.delivery_type));

          // Append Order_details as separate items in FormData
          formfield.append(`order_details[0][product]`, order.id);
          formfield.append(`order_details[0][bdtRate]`, order.price);
          formfield.append(`order_details[0][quantity]`, order.amount);
          formfield.append(
            `order_details[0][linePrice]`,
            order.price * order.amount
          );

          // Append individual fields
          formfield.append("total_amount", Number(values.total_amount));
          formfield.append("discount", Number(values.discount));
          formfield.append("payable_amount", Number(values.payable_amount));
          formfield.append("paid_amount", Number(values.paid_amount));
          formfield.append("due_amount", Number(values.due_amount));
          formfield.append("delivery_charge", Number(values.delivery_charge));
          formfield.append(
            "grand_total_amount",
            Number(values.grand_total_amount)
          );

          await axios({
            method: "POST",
            url: Customer_Order_Post_URL,
            headers: {
              "Content-Type": "application/json; charset=UTF-8; text/plain",
            },
            data: formfield,
          })
            .then((response) => {
              setOrderSubmitted(true);
              // clearCart();
            })
            .catch((error) => {
              console.log(error);
            });
        };

        AddOrderFunc();
      })
      .catch((error) => {
        console.log(error);
        setMsg(error.response.data.email);
      });
  };

  const submitOrderForm = async (
    values,
    { setErrors, setSubmitting, resetForm }
  ) => {
    try {
      AddCustomerFunc(values);
      setSubmitting(false);
      // resetForm();
      handleShowModal();
    } catch (error) {
      setErrors({ error: error.message });
    }
  };

  const AddLoginOrderFunc = async (values) => {
    let formfield = new FormData();

    values.total_amount = order_total_price;
    values.discount = order_total_discount;
    values.payable_amount = order_total_price - order_total_discount;
    values.paid_amount = paid_amount;
    values.due_amount = order_total_price - order_total_discount - paid_amount;
    values.delivery_charge = deliveryPrice;
    values.grand_total_amount =
      order_total_price -
      order_total_discount -
      paid_amount +
      Number(deliveryPrice);

    // Append individual fields
    formfield.append(
      "payment_method",
      values.payment_method ? values.payment_method : "Cash On Delivery"
    );
    formfield.append("customer", c_user && c_user);
    formfield.append("delivery_type", Number(values.delivery_type));

    // Append Order_details as separate items in FormData
    formfield.append(`order_details[0][product]`, order.id);
    formfield.append(`order_details[0][bdtRate]`, order.price);
    formfield.append(`order_details[0][quantity]`, order.amount);
    formfield.append(`order_details[0][linePrice]`, order.price * order.amount);

    // Append individual fields
    formfield.append("total_amount", Number(values.total_amount));
    formfield.append("discount", Number(values.discount));
    formfield.append("payable_amount", Number(values.payable_amount));
    formfield.append("paid_amount", Number(values.paid_amount));
    formfield.append("due_amount", Number(values.due_amount));
    formfield.append("delivery_charge", Number(values.delivery_charge));
    formfield.append("grand_total_amount", Number(values.grand_total_amount));

    await axios({
      method: "POST",
      url: Customer_Order_Post_URL,
      headers: {
        "Content-Type": "application/json; charset=UTF-8; text/plain",
      },
      data: formfield,
    })
      .then((response) => {
        setOrderSubmitted(true);
        // clearCart();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const submitLoginOrderForm = async (
    values,
    { setErrors, setSubmitting, resetForm }
  ) => {
    try {
      AddLoginOrderFunc(values);
      setSubmitting(false);
      // resetForm();
      handleShowModal();
    } catch (error) {
      setErrors({ error: error.message });
    }
  };

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedUpazila, setSelectedUpazila] = useState("");

  const handleDistrictChange = (e) => {
    const selectedDistrictName = e.target.value;
    setSelectedDistrict(
      district.find((district) => district.name === selectedDistrictName)
    );
    setSelectedUpazila("");
  };

  const handleUpazilaChange = (e) => {
    const selectedUpazilaName = e.target.value;
    setSelectedUpazila(
      upazila.find((upazila) => upazila.name === selectedUpazilaName)
    );
  };

  const [showModal, setShowModal] = useState(false);
  const [orderSubmitted, setOrderSubmitted] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleModalClick = () => {
    handleCloseModal();
    navigate(aT ? "/order" : "/"); // assuming you have a `navigate` function from React Router
    window.location.reload(false);
  };

  const renderOrderSummaryModal = () => {
    return (
      <Modal
        show={showModal}
        onHide={() => {
          handleCloseModal();
          handleModalClick();
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Order Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body onClick={handleModalClick}>
          Thank you for your order..
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleCloseModal();
              handleModalClick();
            }}
          >
            Okay
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  return (
    <div className="container checkout mt-5">
      <h2
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
        CHECKOUT FOR DIRECT ORDER
      </h2>

      <Formik
        initialValues={initialValues}
        validationSchema={aT ? schema : customerSchema}
        validate={aT ? validate : customerValidate}
        onSubmit={aT ? submitLoginOrderForm : submitOrderForm}
      >
        {({
          handleSubmit,
          handleChange,
          isSubmitting,
          values,
          errors,
          touched,
        }) => (
          <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
            <div className="checkout-box mt-5">
              {isEmpty(order) === false ? (
                <div
                  style={{
                    height: "250px",
                    overflowX: "auto",
                    overflowY: "auto",
                  }}
                  className="d-flex flex-column"
                >
                  <Card
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <Card.Header>
                      <Card.Img variant="top" height={180} src={order.image} />
                    </Card.Header>

                    <Card.Body
                      className="text-center "
                      style={{
                        fontSize: "40px",
                      }}
                    >
                      <h5>{order.name}</h5>
                      <del>
                        <p className="my-1">
                          Price: <FormatPrice price={order.price} />
                        </p>
                      </del>
                      <p className="my-0">
                        Discount Price:{" "}
                        <FormatPrice price={order.price - order.discount} />
                      </p>
                    </Card.Body>

                    <Card.Footer
                      className="text-center my-0"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h6 style={{ fontSize: "25px", fontWeight: "200" }}>
                        Amount : {order.amount}
                      </h6>

                      <i
                        onClick={() => clearOrder()}
                        className="fa fa-trash trashbtn"
                        aria-hidden="true"
                        style={{ fontSize: "25px", color: "red" }}
                      ></i>
                    </Card.Footer>
                  </Card>
                </div>
              ) : (
                <div
                  style={{
                    height: "250px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    fontSize: "40px",
                    fontWeight: "600",
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  No order selected..!!
                  <NavLink to="/product">
                    <Button className="normalll ">Continue Shopping</Button>
                  </NavLink>
                </div>
              )}

              {aT ? (
                ""
              ) : (
                <div className="checkout-customer">
                  <Form.Group className="form-outline mb-4 ">
                    <Form.Label>
                      Customer Name<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="text"
                        name="name"
                        id="name"
                        value={values.name}
                        onChange={handleChange}
                        isInvalid={!!touched.name && !!errors.name}
                        isValid={touched.name && !errors.name}
                        className="form-control"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-4 ">
                    <Form.Label>
                      Phone<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="text"
                        name="email"
                        id="email"
                        value={values.email}
                        onChange={handleChange}
                        isInvalid={!!touched.email && !!errors.email}
                        isValid={touched.email && !errors.email}
                        className="form-control"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-4 ">
                    <Form.Label>
                      Customer Address<span>*</span>
                    </Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        as="textarea"
                        name="address"
                        id="address"
                        value={values.address}
                        onChange={handleChange}
                        isInvalid={!!touched.address && !!errors.address}
                        isValid={touched.address && !errors.address}
                        className="form-control"
                        rows="1"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.address}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-4 d-none">
                    <Form.Label>District</Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Select
                        name="district"
                        id="district"
                        value={selectedDistrict ? selectedDistrict.name : ""}
                        onChange={(e) => {
                          handleChange(e);
                          handleDistrictChange(e);
                        }}
                        isInvalid={!!touched.district && !!errors.district}
                        isValid={touched.district && !errors.district}
                        className="form-control"
                      >
                        <option value="">Select</option>
                        {district &&
                          district.map((d, i) => {
                            return (
                              <option value={d.name} key={i}>
                                {d.name}-{d.bn_name}
                              </option>
                            );
                          })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.district}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-4 d-none">
                    <Form.Label>Upazila</Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Select
                        name="upazila"
                        id="upazila"
                        value={selectedUpazila ? selectedUpazila.name : ""}
                        onChange={(e) => {
                          handleChange(e);
                          handleUpazilaChange(e);
                        }}
                        isInvalid={!!touched.upazila && !!errors.upazila}
                        isValid={touched.upazila && !errors.upazila}
                        className="form-control"
                      >
                        <option value="">Select</option>
                        {upazila &&
                          upazila
                            .filter(
                              (upazila) =>
                                upazila.district ===
                                (selectedDistrict ? selectedDistrict.id : null)
                            )
                            .map((upazila) => {
                              return (
                                <option key={upazila.id} value={upazila.name}>
                                  {upazila.name}-{upazila.bn_name}
                                </option>
                              );
                            })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.upazila}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="form-outline mb-4 d-none">
                    <Form.Label>Password</Form.Label>
                    <InputGroup hasValidation>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Control
                        type="password"
                        name="password"
                        id="password"
                        value={values.password}
                        onChange={handleChange}
                        isInvalid={!!touched.password && !!errors.password}
                        isValid={touched.password && !errors.password}
                        className="form-control"
                        autoComplete="on"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </div>
              )}

              <div className="box2">
                <Form.Group className="form-outline  mb-4 col-lg-3 col-sm-6">
                  <Form.Label>
                    Delivery Type<span></span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Select
                      name="delivery_type"
                      id="delivery_type"
                      value={values.delivery_type}
                      onChange={(e) => {
                        handleChange(e);
                        handleDelTypeChange(e);
                      }}
                      isInvalid={
                        !!touched.delivery_type && !!errors.delivery_type
                      }
                      isValid={touched.delivery_type && !errors.delivery_type}
                      className="form-control"
                    >
                      <option value="">Select</option>
                      {isActiveDeliveryType &&
                        isActiveDeliveryType.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}&nbsp;-&nbsp;{item.price}
                              &nbsp;Tk
                            </option>
                          );
                        })}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.delivery_type}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6 d-none">
                  <Form.Label>
                    Payment Method<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Select
                      name="payment_method"
                      id="payment_method"
                      value={values.payment_method}
                      onChange={handleChange}
                      isInvalid={
                        !!touched.payment_method && !!errors.payment_method
                      }
                      isValid={touched.payment_method && !errors.payment_method}
                      className="form-control"
                    >
                      <option value="">Select</option>
                      <option value="Cash On Delivery">Cash On Delivery</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.payment_method}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6 d-none">
                  <Form.Label>
                    Sub Total Amount<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Control
                      type="text"
                      name="total_amount"
                      id="total_amount"
                      value={isNaN(order_total_price) ? 0 : order_total_price}
                      onChange={handleChange}
                      isInvalid={
                        !!touched.total_amount && !!errors.total_amount
                      }
                      isValid={touched.total_amount && !errors.total_amount}
                      readOnly
                      className="form-control"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.total_amount}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6 d-none">
                  <Form.Label>
                    Dsicount<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Control
                      type="text"
                      name="discount"
                      id="discount"
                      value={
                        isNaN(order_total_discount) ? 0 : order_total_discount
                      }
                      onChange={handleChange}
                      isInvalid={!!touched.discount && !!errors.discount}
                      isValid={touched.discount && !errors.discount}
                      readOnly
                      className="form-control"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.discount}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6 d-none">
                  <Form.Label>
                    Payable Amount<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Control
                      type="text"
                      name="payable_amount"
                      id="payable_amount"
                      value={
                        (isNaN(order_total_price) ? 0 : order_total_price) -
                        (isNaN(order_total_discount) ? 0 : order_total_discount)
                      }
                      onChange={handleChange}
                      isInvalid={
                        !!touched.payable_amount && !!errors.payable_amount
                      }
                      isValid={touched.payable_amount && !errors.payable_amount}
                      readOnly
                      className="form-control"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.payable_amount}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6 d-none">
                  <Form.Label>
                    Paid Amount<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Control
                      type="text"
                      name="paid_amount"
                      id="paid_amount"
                      value={paid_amount}
                      onChange={handleChange}
                      isInvalid={!!touched.paid_amount && !!errors.paid_amount}
                      isValid={touched.paid_amount && !errors.paid_amount}
                      readOnly
                      className="form-control"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.paid_amount}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6">
                  <Form.Label>
                    Due Amount<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Control
                      type="text"
                      name="due_amount"
                      id="due_amount"
                      value={
                        (isNaN(order_total_price) ? 0 : order_total_price) -
                        (isNaN(order_total_discount)
                          ? 0
                          : order_total_discount) -
                        paid_amount
                      }
                      onChange={handleChange}
                      isInvalid={!!touched.due_amount && !!errors.due_amount}
                      isValid={touched.due_amount && !errors.due_amount}
                      readOnly
                      className="form-control"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.due_amount}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6 d-none">
                  <Form.Label>
                    Delivery Charge<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Control
                      type="text"
                      name="delivery_charge"
                      id="delivery_charge"
                      value={deliveryPrice}
                      onChange={handleChange}
                      isInvalid={
                        !!touched.delivery_charge && !!errors.delivery_charge
                      }
                      isValid={
                        touched.delivery_charge && !errors.delivery_charge
                      }
                      readOnly
                      className="form-control"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.delivery_charge}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-outline mb-4 col-lg-3 col-sm-6 ">
                  <Form.Label>
                    Total Amount (With Delivery Charge)<span>*</span>
                  </Form.Label>
                  <InputGroup hasValidation>
                    {/* <InputGroup.Text>@</InputGroup.Text> */}
                    <Form.Control
                      type="text"
                      name="grand_total_amount"
                      id="grand_total_amount"
                      value={
                        (isNaN(order_total_price) ? 0 : order_total_price) -
                        (isNaN(order_total_discount)
                          ? 0
                          : order_total_discount) -
                        paid_amount +
                        Number(deliveryPrice)
                      }
                      onChange={handleChange}
                      isInvalid={
                        !!touched.grand_total_amount &&
                        !!errors.grand_total_amount
                      }
                      isValid={
                        touched.grand_total_amount && !errors.grand_total_amount
                      }
                      readOnly
                      className="form-control"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.grand_total_amount}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>

            <div className="hstack gap-2 flex-wrap justify-content-center d-print-none my-4">
              <button
                disabled={isSubmitting}
                type="submit"
                className="normal"
                onClick={handleShowModal}
              >
                Place Order
              </button>
            </div>

            <p
              style={{
                marginTop: "10px",
                textAlign: "center",
                color: "red",
                fontSize: "15px",
                textTransform: "capitalize",
              }}
            >
              {msg}
            </p>

            {orderSubmitted && renderOrderSummaryModal()}
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default Ordercheckout;
